'use client';

import React from 'react';
import classNames from 'classnames';
import { Icon } from '@benzinga/core-ui';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/user/BenzingaTV?sub_confirmation=1';

const compactClasses =
  'inline-flex h-10 min-w-[96px] items-center justify-center gap-1.5 rounded bg-[#ff0000] px-3 text-sm font-bold leading-none text-white hover:bg-[#cc0000] hover:text-white';

const subscribeClasses =
  'inline-flex min-h-11 items-center justify-center gap-2 rounded-lg bg-[#ff0000] px-5 py-2.5 text-[15px] font-bold leading-tight text-white whitespace-nowrap hover:bg-[#d90000] hover:text-white';

const prominentClasses =
  'inline-flex min-h-10 items-center justify-center gap-2 rounded bg-[#ff0000] px-4 py-2 text-sm font-bold leading-tight text-white hover:bg-[#cc0000] hover:text-white';

export interface YouTubeFollowButtonProps {
  className?: string;
  variant?: 'compact' | 'prominent' | 'subscribe';
}

export const YouTubeFollowButton: React.FC<YouTubeFollowButtonProps> = ({ className = '', variant = 'compact' }) => {
  if (variant === 'subscribe') {
    return (
      <a
        aria-label="Subscribe to Benzinga on YouTube"
        className={classNames('youtube-follow-button youtube-follow-button--subscribe', subscribeClasses, className)}
        href={YOUTUBE_CHANNEL_URL}
        rel="noreferrer"
        target="_blank"
      >
        <Icon className="shrink-0 text-xl" icon={faYoutube} />
        <span>Subscribe on YouTube</span>
      </a>
    );
  }

  if (variant === 'prominent') {
    return (
      <a
        aria-label="Follow Benzinga on YouTube"
        className={classNames('youtube-follow-button youtube-follow-button--prominent', prominentClasses, className)}
        href={YOUTUBE_CHANNEL_URL}
        rel="noreferrer"
        target="_blank"
      >
        <Icon className="shrink-0 text-2xl" icon={faYoutube} />
        <span>Follow us on YouTube</span>
      </a>
    );
  }

  return (
    <a
      aria-label="Follow Benzinga on YouTube"
      className={classNames('youtube-follow-button youtube-follow-button--compact', compactClasses, className)}
      href={YOUTUBE_CHANNEL_URL}
      rel="noreferrer"
      target="_blank"
    >
      <Icon className="text-xl" icon={faYoutube} />
      <span>YouTube</span>
    </a>
  );
};

export default YouTubeFollowButton;
